export default __webpack_public_path__ + "assets/front/scss/classification-browsing.1d7c3e6b9b8f8fd1d71f3c3efbd38c15.css";